import ServiceApi from "../services/service.api";



const baseContactIdUrl=`/api/v1/ContactInfo`;



const ApiContact = {

    // get all data from backend.
    getAll: (params) => {
        // params = {PageNumber:integer, PageSize:integer, GlobalSearch:string}
        const url = `/api/v1/ContactInfo/GetAllContactInfo`;
        return ServiceApi.get(url,{params});
      },
    //   ---------------------------------------------------------------------
    //   get a  data from backend by id.
      get: (id) => {
        const url = `/api/v1/ContactInfo/${id}`;
        return ServiceApi.get(url);
      },
    //   ---------------------------------------------------------------------
    //   creat a new data in backend .
    create: (input) => {

        const url = `/api/v1/ContactInfo/CreateContactInfo`;
        return ServiceApi.post(url, input);
      },

      //   ---------------------------------------------------------------------
        //  updata data by getting id 
      update: (id, data) => {
        const url = `/api/v1/ContactInfo/UpdateContactInfo`;
        return ServiceApi.put(url, data);
      },


};

export default ApiContact